import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCaptionGenerationStarted.meta';

export type UseTrackCaptionGenerationStartedParams = {
  video_id: string;
  duration_seconds: number;
};

export const useTrackCaptionGenerationStarted = () => {
  const { track } = useAnalyticsUtilities();

  const trackCaptionGenerationStarted = useCallback(
    (params: UseTrackCaptionGenerationStartedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCaptionGenerationStarted };
};
